import { projectState } from '@app/store/projectStore.svelte.js';
import { backfillAudioRenderHashes } from '@app/lib/audio/audioRenderState.js';
import { isGroupLockedExternally } from '@app/store/permissionStore.svelte.js';
import { isGroupAgentLocked } from '@app/lib/assistant/agent/agentEditLock.svelte.js';

export const eventGroupState = $state([]);

/**
 * Resets the event group state to an empty array without reassigning the state variable
 */
export function resetEventGroupState() {
    // Clear the array by setting its length to 0
    eventGroupState.length = 0;
}

/**
 * Sets the event group state with the provided array of event groups
 * @param {Array} eventGroups - The array of event groups to set in the state
 */
export function setEventGroupState(eventGroups) {
    // Clear existing event groups first
    resetEventGroupState();
    eventGroups.forEach(eventGroup => {
        eventGroupState.push({
            ...eventGroup
        })
    })
    backfillAudioRenderHashes(eventGroupState);
}

/**
 * Whether the event group at the given index is locked for content editing,
 * including while the AI agent is writing to it.
 * @param {number} [index=projectState.selected]
 * @returns {boolean}
 */
export function isEventGroupLocked(index = projectState.selected) {
    const group = eventGroupState[index];
    return Boolean(group?.locked) || isGroupLockedExternally(group) || isGroupAgentLocked(group?.id);
}

/**
 * Whether the event group at the given index is locked by the parent window or
 * the active iframe role (the user cannot unlock it).
 * @param {number} [index=projectState.selected]
 * @returns {boolean}
 */
export function isEventGroupLockedExternally(index = projectState.selected) {
    return isGroupLockedExternally(eventGroupState[index]);
}

/**
 * Whether the event group with the given id is locked.
 * @param {string} id
 * @returns {boolean}
 */
export function isEventGroupIdLocked(id) {
    const index = eventGroupState.findIndex((group) => group.id === id);
    return index !== -1 && isEventGroupLocked(index);
}

/**
 * Whether the currently selected event group is locked for content editing.
 * @returns {boolean}
 */
export function isSelectedEventGroupLocked() {
    return isEventGroupLocked(projectState.selected);
}